<template>
  <footer class="footer px-4 bg-transparent">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="text-center text-muted">
          Copyright &copy; {{ year }}
          <a
            href="https://www.mouth2mouth-app.com/"
            target="_blank"
            rel="noopener"
          >
            M2M /
          </a>
          <a href="https://www.nextstation.cl" target="_blank" rel="noopener">
            Nextstation
          </a>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="text-center text-muted">
          <b-link
            @click="$router.push({ name: 'terms-of-service' })"
            target="_blank"
          >
            {{ $t("term") }} & {{ $t("condition") }}</b-link
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
